import {
    ISRESULT,
    GET_DATA_LOGIN_LOGIN, GET_DATA_LOGIN_LOGIN_SUCCEEDED, REQUERT_LOGIN_LOGIN_FAILED, SET_DATA_LOGIN_LOGIN,
    LOGIN,LOGIN_SUCCEEDED,LOGIN_FAILED
    //IndexImportHygen
} from './actionTypes';

export const IsResultAction = (isResult) => {
    return {
        type: ISRESULT,
        isResult: isResult
    }
}

//LoginLogin
export const GetDataLoginLoginAction = () => {
    return {
        type: GET_DATA_LOGIN_LOGIN
    }
}
export const GetDataLoginLoginSuccessAction = (DataLogin) => {
    return {
        type: GET_DATA_LOGIN_LOGIN_SUCCEEDED,
        DataLogin: DataLogin
    }
}
export const RequertLoginLoginFaileAction = (Err) => {
    return {
        type: REQUERT_LOGIN_LOGIN_FAILED,
        err: Err
    }
}
export const SetDataLoginLoginAction = (DataLogin) => {
    return {
        type: SET_DATA_LOGIN_LOGIN,
        DataLogin: DataLogin
    }
}
export const LoginAction = (token) => {
    return {
        type: LOGIN,
        token: token
    }
}
export const LoginSuccessAction = (ResultLogin) => {
    return {
        type: LOGIN_SUCCEEDED,
        resultLogin: ResultLogin
    }
}
export const LoginFaileAction = (Err) => {
    return {
        type: LOGIN_FAILED,
        err: Err
    }
}
//IndexUsingHygen